import React from 'react';
const comparisonRows = [{
  without: 'Sin sistema 👉 entendés pero volvés a lo mismo',
  with: 'Con sistema 👉 aplicás y sostenés el cambio'
}, {
  without: 'Reaccionás automáticamente',
  with: 'Respondés con claridad'
}, {
  without: 'Cargás emociones del pasado',
  with: 'Soltás lo que te pesa'
}, {
  without: 'Te sentís en conflicto interno',
  with: 'Sentís más paz y liviandad'
}, {
  without: 'Evitás conversaciones o explotás',
  with: 'Sabés cuándo y cómo actuar'
}, {
  without: 'Dependés de que el otro cambie',
  with: 'Cambias vos y cambia la dinámica'
}, {
  without: 'Todo sigue igual',
  with: 'Empezás a ver cambios reales'
}];
export function ComparisonTableExtended() {
  return <section className="text-white py-5 px-5 bg-[#000000]" data-id="element-77">
      <div className="max-w-xl mx-auto" data-id="element-78">
        <h3 className="text-base md:text-lg font-black text-white mb-4 flex items-center gap-2" data-id="element-79">
          🧠 TABLA COMPARATIVA
        </h3>

        {/* Column headers */}
        <div className="grid grid-cols-2 gap-3 mb-3" data-id="element-80">
          <div className="text-xs font-bold text-red-400 flex items-center gap-1" data-id="element-81">
            ❌ Sin sistema
          </div>
          <div className="text-xs font-bold text-green-400 flex items-center gap-1" data-id="element-82">
            ✅ Con sistema
          </div>
        </div>

        {/* Rows */}
        <div className="space-y-2" data-id="element-83">
          {comparisonRows.map((row, idx) => <div key={idx} className="grid grid-cols-2 gap-3 border-t border-slate-800/60 pt-3" data-id="element-84">
              <p className="text-xs text-slate-500 leading-relaxed" data-id="element-85">
                {row.without}
              </p>
              <p className="text-xs text-slate-300 leading-relaxed" data-id="element-86">
                {row.with}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}